import React, { useEffect } from "react";
import CompanyTable from "./CompanyTable";
import { useSelector, useDispatch } from "react-redux";
import { getSavedSuppliers } from "../../../store/suppliersManagementSlice";

const SavedSuppliers = ({ isSavedSuppliers}) => {
    const buyerId = useSelector((state) => state.auth.id);
  const dispatch = useDispatch();
  const { saved: savedSuppliers, loading } = useSelector(
    (state) => state.suppliers
  );

  useEffect(() => {
    if (buyerId) {
      dispatch(getSavedSuppliers(buyerId));
    }
  }, [buyerId, dispatch]);

  return (
    <div style={{ background: "#F5F5F5", minHeight: "100vh" }}>
      {loading ? (
        <p className="text-center py-10">Loading suppliers...</p>
      ) : (
        <CompanyTable
          suppliers={savedSuppliers}
          isSavedSuppliers={isSavedSuppliers}
          selectedTab="Saved Suppliers"
        />
      )}
    </div>
  );
};

export default SavedSuppliers;
